module.exports = __webpack_public_path__ + "images/podcast_640.c2fb1ae9f8b5412f0c47c7ec3ccbb741.png";